import React from "react";

export default function Home() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "70vh",
        padding: "100px 32px",
      }}
    >
      <h1 className="title-cool">Authorized use only.</h1>
    </div>
  );
}
